module.exports = __webpack_public_path__ + "static/media/34.09129e37.jpg";